import { render, staticRenderFns } from "./PortalPage.vue?vue&type=template&id=1d71de77&scoped=true"
import script from "./PortalPage.vue?vue&type=script&lang=js"
export * from "./PortalPage.vue?vue&type=script&lang=js"
import style0 from "./PortalPage.vue?vue&type=style&index=0&id=1d71de77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d71de77",
  null
  
)

export default component.exports